import React from "react";

import {
  Outlet,
  NavLink
} from "react-router-dom";

export default function Utilities(props) {

  const classes = ({ isActive }) =>
    isActive ? "utils-nav__link utils-nav__link--active"
      : "utils-nav__link";

  return (
    <div className="utils">
      <div className="header border-bottom border-top-right-radius-8">
        <span>Utilitários</span>
      </div>

      <div className="utils-nav">
        <ul className="utils-nav__list">
          <li className="utils-nav__item">
            <NavLink to="tags" className={classes}>Tags</NavLink>
          </li>

          <li className="utils-nav__item">
            <NavLink to="presets" className={classes}>Presets</NavLink>
          </li>
        </ul>
      </div>

      <div className="utils__body">
        <Outlet />
      </div>
    </div>
  );
}